import { MarkdownRenderer } from '@components/markdown-renderer';
import MED_INFO_CONTENT from '@constants/med-info-content';
import { CURRENT_INSTANCE } from '@lib/utils';
import { useTranslation } from 'react-i18next';
import AnswerMessageContainer from './answer-message-container';

function InvalidQueryResponse() {
  const { t } = useTranslation();

  return (
    <AnswerMessageContainer>
      <div>
        {t('chat.response.invalid_query_intro')}
        <br />
        <br />
        <MarkdownRenderer content={MED_INFO_CONTENT[CURRENT_INSTANCE.name].de} />
      </div>
    </AnswerMessageContainer>
  );
}

export default InvalidQueryResponse;
